import { StyledShareDisplayContainer } from 'components/Selfiebooth/ShareDisplay/styled'
import { useState } from 'react'
import Consent from 'components/Selfiebooth/ShareDisplay/consent'
import Share from 'components/Selfiebooth/ShareDisplay/share'
import { SelfieBoothType } from '../../../types/selfiebooth'

interface ShareDisplayProps {
	selfiebooth: SelfieBoothType;
	app: any;
	finalImg: string;
	visitorId: string;
	cardInfos: any;
	onCancel: () => void;
	isModal: boolean;
}

const ShareDisplay = ({ app, selfiebooth, finalImg, cardInfos, visitorId, onCancel, isModal }: ShareDisplayProps) => {
	const [step, setStep] = useState<'consent'|'share'>('consent');
	const [fileId, setFileId] = useState<string|null>(null)

	return <>
		<StyledShareDisplayContainer $isModal={isModal}>
			{step === 'consent' && <>
				<Consent
					app={app}
					selfiebooth={selfiebooth}
					finalImg={finalImg}
					onCancel={onCancel}
					visitorId={visitorId}
					cardInfos={cardInfos}
					nextStep={() => setStep('share')}
          getFileId={setFileId}
				/>
			</>}
			{step === 'share' && <Share selfiebooth={selfiebooth} finalImg={finalImg} onCancel={onCancel} fileId={fileId} app={app} />}
		</StyledShareDisplayContainer>
	</>;
};

export default ShareDisplay;